"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  UserWidget: true,
  UserSettings: true
};
exports.UserSettings = UserSettings;
exports.UserWidget = UserWidget;

var _react = _interopRequireDefault(require("react"));

var _reactBootstrap = require("react-bootstrap");

var _firebase = require("../firebase");

var _Login = require("./Login");

Object.keys(_Login).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Login[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Login[key];
    }
  });
});

var _CreateAccount = require("./CreateAccount");

Object.keys(_CreateAccount).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _CreateAccount[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CreateAccount[key];
    }
  });
});

var _ForgotPass = require("./ForgotPass");

Object.keys(_ForgotPass).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ForgotPass[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ForgotPass[key];
    }
  });
});
var _excluded = ["buttons"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function UserWidget(props) {
  var _user$claims;

  var buttons = props.buttons,
      otherProps = _objectWithoutProperties(props, _excluded);

  var user = (0, _firebase.useAuth)();
  buttons = buttons || []; // add admin button

  if ((user === null || user === void 0 ? void 0 : (_user$claims = user.claims) === null || _user$claims === void 0 ? void 0 : _user$claims.admin) === true) {
    buttons.push({
      key: "Admin",
      content: "Admin",
      href: "https://admin.bythebookthebible.com"
    });
  } //   // add user settings button
  //   if(user?.claims?.admin === true) {
  //     buttons.push({
  //       key: "Settings",
  //       content: "Settings", 
  //       href: "/settings"
  //     })
  //   }
  // add logout button


  if (user) {
    buttons = [{
      key: "Name",
      content: user.displayName,
      disabled: true
    }, {
      key: "Manage",
      content: "Manage Account",
      href: "/account"
    }, {
      key: "Logout",
      content: "Logout",
      onClick: function onClick() {
        _firebase.auth.signOut().catch(function (e) {
          console.log('Signout error: ', e);
        });
      }
    }].concat(_toConsumableArray(buttons));
  }

  if (!user) return null;else return [/*#__PURE__*/_react.default.createElement(_reactBootstrap.NavDropdown, {
    title: /*#__PURE__*/_react.default.createElement("i", {
      className: "fas fa-user",
      style: {
        fontSize: "1.5rem",
        padding: 0
      }
    }),
    as: "i"
  }, buttons && buttons.map(function (b) {
    return /*#__PURE__*/_react.default.createElement(_reactBootstrap.NavDropdown.Item, _extends({}, otherProps, {
      disabled: b.disabled,
      onClick: b.onClick,
      href: b.href,
      key: b.key
    }), b.content);
  })), user.online ? "" : "offline"];
}

function UserSettings(props) {
  var user = props.user;
  console.log(user, user.claims);
  return user && /*#__PURE__*/_react.default.createElement("table", {
    className: "container form"
  }, /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("label", null, "--COMING SOON--")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("label", null, "Full Name")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("input", {
    type: "text",
    defaultValue: user.displayName
  })), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("label", null, "Email")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("input", {
    type: "email",
    defaultValue: user.email
  })), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("button", {
    readOnly: true,
    onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))
  }, "Submit Changes")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("label", null, "Subscription Plan"))));
}